import React, { useEffect, useState } from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import { BookingOiqiaQl, InfoCardTextProps } from "../../../types/types";
import Queries from "../../../api/queries";
import { mobUser } from "../../../mobx/MobUser";
import { ApolloQueryResult } from "@apollo/client";
import i18n from "../../../i18n";
import InvoiceForm from "./InvoiceForm";
import InfoCard from "../../../components/InfosCard";
import { SafeAreaView } from "react-native-safe-area-context";
import { useRoute } from "@react-navigation/native";
import FooterDivider from "../../../components/FooterDivider";

const Invoice = () => {

  const route = useRoute();
  const { alreadyAsked = false } = route.params;

  const [fields, setFields] = useState<InfoCardTextProps[]>();
  const [resaInfos, setResaInfos] = useState<BookingOiqiaQl>();
  const queries = new Queries();

  useEffect(() => {
    let subscription;

    async function fetchBookingDataAndReceiptStatus() {
      try {
        const observable = await queries.getBookingById(mobUser.OiqiaBookingId);
        subscription = observable.subscribe({
          next(response: ApolloQueryResult<{ NTA_getBookingById: BookingOiqiaQl }>) {
            if (response.data?.NTA_getBookingById) {
              setResaInfos(response.data?.NTA_getBookingById);
              setFields([
                { title: i18n.t("pages.checkIn.firstName"), text: response.data.NTA_getBookingById?.firstName },
                { title: i18n.t("pages.checkIn.lastName"), text: response.data.NTA_getBookingById?.lastName },
              ]);
            }
          },
          error(err) {
            console.error("Error fetching booking data:", err);
          }
        });

        return () => {
          subscription?.unsubscribe();
        };
      } catch (error) {
        console.error("Error setting up subscription:", error);
      }
    }

    fetchBookingDataAndReceiptStatus();

    return () => {
      subscription?.unsubscribe();
    };
  }, []);

  return (
    <SafeAreaView style={{ flex: 1 }} edges={['bottom']}>
      <ScrollView
        contentContainerStyle={styles.container}
        keyboardDismissMode="interactive"
        automaticallyAdjustKeyboardInsets={true}
      >
        <View style={styles.subContainer}>
          <InfoCard fieldMap={fields} />
          <InvoiceForm checkInInfos={resaInfos} alreadyAsked={alreadyAsked} />
        </View>
        <FooterDivider />
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
  },
  subContainer: {
    marginVertical: 20,
    width: "80%",
    gap: 25
  },
});

export default Invoice;